var _defineProperty = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");

var _propertyTypes$COMMER, _buyerTypes$FIRST_TIM, _propertyTypes$RESIDE, _sdltBands, _taxNames;

var additionalPropertySurcharge = 3;
var percent = String.fromCharCode(37);
var countries = {
  ENGLAND: 'england',
  SCOTLAND: 'scotland',
  WALES: 'wales',
  IRELAND: 'ireland'
};
var propertyTypes = {
  COMMERCIAL: 'commercial',
  RESIDENTIAL: 'residential'
};
var buyerTypes = {
  FIRST_TIME: 'first',
  MOVING_HOUSE: 'home',
  INVESTOR: 'investor'
};
var ireland = [{
  upto: 1000000,
  rate: 1
}, {
  upto: 'end',
  rate: 2
}];
var scotland = [{
  upto: 250000,
  rate: 2,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 325000,
  rate: 5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 750000,
  rate: 10,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 'end',
  rate: 12,
  additionalPropertySurcharge: additionalPropertySurcharge
}];
var sdltBands = (_sdltBands = {}, _defineProperty(_sdltBands, propertyTypes.COMMERCIAL, (_propertyTypes$COMMER = {}, _defineProperty(_propertyTypes$COMMER, countries.ENGLAND, [{
  upto: 150000,
  rate: 0
}, {
  upto: 250000,
  rate: 2
}, {
  upto: 'end',
  rate: 5
}]), _defineProperty(_propertyTypes$COMMER, countries.WALES, [{
  upto: 150000,
  rate: 0
}, {
  upto: 250000,
  rate: 1
}, {
  upto: 1000000,
  rate: 5
}, {
  upto: 'end',
  rate: 6
}]), _defineProperty(_propertyTypes$COMMER, countries.SCOTLAND, [{
  upto: 150000,
  rate: 0
}, {
  upto: 250000,
  rate: 1
}, {
  upto: 'end',
  rate: 5
}]), _defineProperty(_propertyTypes$COMMER, "ireland", ireland), _propertyTypes$COMMER)), _defineProperty(_sdltBands, propertyTypes.RESIDENTIAL, (_propertyTypes$RESIDE = {}, _defineProperty(_propertyTypes$RESIDE, buyerTypes.FIRST_TIME, (_buyerTypes$FIRST_TIM = {}, _defineProperty(_buyerTypes$FIRST_TIM, countries.ENGLAND, {
  thresholds: [// { upto: 500000, rate: 0 },
  {
    upto: 300000,
    rate: 0
  }, {
    upto: 500000,
    rate: 5
  }],
  limit: 500000
}), _defineProperty(_buyerTypes$FIRST_TIM, countries.SCOTLAND, {
  thresholds: [{
    upto: 175000,
    rate: 0
  }].concat(scotland),
  limit: -1
}), _buyerTypes$FIRST_TIM)), _defineProperty(_propertyTypes$RESIDE, countries.ENGLAND, [// { upto: 500000, rate: 0, additionalPropertySurcharge },
// { upto: 125000, rate: 0, additionalPropertySurcharge },
{
  upto: 250000,
  rate: 0,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 925000,
  rate: 5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 1500000,
  rate: 10,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 'end',
  rate: 12,
  additionalPropertySurcharge: additionalPropertySurcharge
}]), _defineProperty(_propertyTypes$RESIDE, countries.WALES, [{
  upto: 180000,
  rate: 0,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 250000,
  rate: 3.5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 400000,
  rate: 5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 750000,
  rate: 7.5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 1500000,
  rate: 10,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 'end',
  rate: 12,
  additionalPropertySurcharge: additionalPropertySurcharge
}]), _defineProperty(_propertyTypes$RESIDE, countries.SCOTLAND, [{
  upto: 145000,
  rate: 0,
  additionalPropertySurcharge: additionalPropertySurcharge
}].concat(scotland)), _defineProperty(_propertyTypes$RESIDE, "ireland", ireland), _propertyTypes$RESIDE)), _sdltBands);
var englandFirstTimeLimit = sdltBands[propertyTypes.RESIDENTIAL][buyerTypes.FIRST_TIME][countries.ENGLAND].limit;
var comments = {
  firstTimeWales: 'there is no separate first time buyer exemption in Wales',
  under40kUKInvestor: 'all transactions below 40k in UK are exempt from ',
  UKInvestor: "".concat(additionalPropertySurcharge + percent, " surcharge is applied"),
  firstTimeEnglandOverLimit: "properties over ".concat(englandFirstTimeLimit, " do not attract first time buyer relief"),
  EMPTY: ''
};
var taxNames = (_taxNames = {}, _defineProperty(_taxNames, countries.ENGLAND, {
  long: 'stamp duty land tax',
  short: 'SDLT'
}), _defineProperty(_taxNames, countries.IRELAND, {
  long: 'stamp duty',
  short: 'stamp duty'
}), _defineProperty(_taxNames, countries.SCOTLAND, {
  long: 'land and buildings tax',
  short: 'LBTT'
}), _defineProperty(_taxNames, countries.WALES, {
  long: 'land transaction tax',
  short: 'LTT'
}), _taxNames);
var config = {
  sdltBands: sdltBands,
  countries: countries,
  propertyTypes: propertyTypes,
  buyerTypes: buyerTypes,
  comments: comments,
  englandFirstTimeLimit: englandFirstTimeLimit,
  taxNames: taxNames
};
module.exports = config;